<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']"  :style="{
      background: tenantConfig.homeBgColor,
      'background-image': 'url(' + tenantConfig.homeBg + ')',
      'background-repeat': tenantConfig.homeBgRepeat,
    }">
    <div class="wide">
      <router-view />
    </div>
    <!-- <a-back-top /> -->
    <!-- <Footer /> -->
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import Footer from "@/components/footer/Footer";
export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Footer,
  },
  data() {
    return {
      tenantConfig: {},
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.container {
  // padding-top: 75px;
  background: #f2f6f8;
  .cms {
    max-width: 100%;
    margin: 20px auto 20px;
    padding: 20px;
    background: #ffffffd1;
    border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
}
</style>